import type { FilesByInsuredQuery } from "@qw/graphql";
import { createContext, useContext } from "react";
import type { TreeNode } from "../util/build-tag-tree";

type Files = FilesByInsuredQuery["filesByInsured"];
export type InsuredFile = Files[number];

interface InsuredFilesContextValue {
  correspondence: boolean;
  deletedFiles: boolean;
  fileId?: string;
  fileLabels: boolean;
  /** Every listed file; folder and search filtering happen in `groupInsuredFiles`. */
  files: Files;
  foldersVisible: boolean;
  insuredId: string;
  loading: boolean;
  query: string;
  selectedFile?: InsuredFile;
  selectedTags: string;
  tagTree: TreeNode[];
  setCorrespondence: (update: React.SetStateAction<boolean>) => void;
  setDeletedFiles: (update: React.SetStateAction<boolean>) => void;
  setFileLabels: (update: React.SetStateAction<boolean>) => void;
  setFoldersVisible: (update: React.SetStateAction<boolean>) => void;
  setQuery: (update: React.SetStateAction<string>) => void;
  setSelectedFile: (file: InsuredFile | undefined) => void;
  setSelectedTags: (update: React.SetStateAction<string>) => void;
}

export const InsuredFilesContext = createContext<InsuredFilesContextValue | null>(null);

export const useInsuredFiles = () => {
  const context = useContext(InsuredFilesContext);

  if (!context) {
    throw new Error("useInsuredFiles must be used within a InsuredFilesProvider");
  }

  return context;
};

export const useOptionalInsuredFiles = () => useContext(InsuredFilesContext);
